'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';

/**
 * Product-page line for the HM special (code) sale: the product is in a sale
 * with no price change, and the discount is applied by entering the code in
 * the cart. Renders nothing unless the `millerknoll_hm20_promotion_active`
 * preference is on,
 * the product's supplier is in the MillerKnoll group, and the product is
 * flagged on_sale. Fetches live state so the preference flip takes effect
 * immediately despite static product pages.
 *
 * Copy is the owner's (2026-09-28).
 */
const HmSpecialSaleProductMessage = t0 => {
  const $ = _c(5);
  const {
    supplier_id,
    on_sale
  } = t0;
  const [active, setActive] = useState(false);
  let t1;
  let t2;
  if ($[0] !== on_sale || $[1] !== supplier_id) {
    t1 = () => {
      if (!supplier_id || on_sale != 1) {
        return;
      }
      let cancelled = false;
      fetch("/api/special-sale").then(_temp).then(data => {
        if (cancelled || !data?.active) {
          return;
        }
        if (!data.supplier_ids?.includes(Number(supplier_id))) {
          return;
        }
        setActive(true);
      }).catch(_temp2);
      return () => {
        cancelled = true;
      };
    };
    t2 = [supplier_id, on_sale];
    $[0] = on_sale;
    $[1] = supplier_id;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!active) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-4 text-sm leading-tight text-right"><div className="text-red">Save 20% With Code HM20</div><div className="mt-1.5 text-xs text-red">enter promotion code in your cart</div></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default HmSpecialSaleProductMessage;
function _temp(res) {
  return res.json();
}
function _temp2() {}